export default __webpack_public_path__ + "static/media/senior-health-4.598ba9d3.svg";